import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "v",
  "data-class": "v"
}
const _hoisted_2 = { class: "vcount" }
const _hoisted_3 = ["textContent"]
const _hoisted_4 = { class: "vcards" }
const _hoisted_5 = {
  key: 1,
  class: "vloading"
}
const _hoisted_6 = ["textContent"]
const _hoisted_7 = {
  key: 2,
  class: "vloading"
}
const _hoisted_8 = ["textContent"]
const _hoisted_9 = {
  key: 4,
  class: "vmore"
}
const _hoisted_10 = ["textContent"]
const _hoisted_11 = {
  key: 5,
  class: "vpower"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Powered by ")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://github.com/walinejs/waline",
  target: "_blank",
  rel: "noreferrer"
}, " Waline ", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommentBox = _resolveComponent("CommentBox")!
  const _component_CommentCard = _resolveComponent("CommentCard")!
  const _component_LoadingIcon = _resolveComponent("LoadingIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.reply)
      ? (_openBlock(), _createBlock(_component_CommentBox, {
          key: 0,
          onSubmit: _ctx.onSubmit
        }, null, 8 /* PROPS */, ["onSubmit"]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.count)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: "vnum",
            textContent: _toDisplayString(_ctx.count)
          }, null, 8 /* PROPS */, _hoisted_3))
        : _createCommentVNode("v-if", true),
      _createTextVNode(" " + _toDisplayString(_ctx.locale.comment), 1 /* TEXT */)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (comment) => {
        return (_openBlock(), _createBlock(_component_CommentCard, {
          key: comment.objectId,
          "root-id": comment.objectId,
          comment: comment,
          reply: _ctx.reply,
          onReply: _ctx.onReply,
          onSubmit: _ctx.onSubmit
        }, null, 8 /* PROPS */, ["root-id", "comment", "reply", "onReply", "onSubmit"]))
      }), 128 /* KEYED_FRAGMENT */))
    ]),
    (_ctx.inError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("button", {
            type: "button",
            class: "vbtn",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.refresh && _ctx.refresh(...args))),
            textContent: _toDisplayString(_ctx.locale.refresh)
          }, null, 8 /* PROPS */, _hoisted_6)
        ]))
      : (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_LoadingIcon, { size: 30 })
          ]))
        : (!_ctx.data.length)
          ? (_openBlock(), _createElementBlock("div", {
              key: 3,
              class: "vempty",
              textContent: _toDisplayString(_ctx.locale.sofa)
            }, null, 8 /* PROPS */, _hoisted_8))
          : _createCommentVNode("v-if", true),
    (_ctx.page < _ctx.totalPages && !_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("button", {
            type: "button",
            class: "vbtn",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.loadMore && _ctx.loadMore(...args))),
            textContent: _toDisplayString(_ctx.locale.more)
          }, null, 8 /* PROPS */, _hoisted_10)
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.config.copyright)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _hoisted_12,
          _hoisted_13,
          _createTextVNode(" v" + _toDisplayString(_ctx.version), 1 /* TEXT */)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}